var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { sanitizePhoneNumber } from './general';
import { B2B_HOMEPAGE_PATH } from '../constants/links';
var getCityStateObjectFromStr = function (value) { return ({
    city: value.split(', ')[0],
    state: value.split(', ')[1],
}); };
export var redirectToB2bHomePage = function () {
    window.location.assign("".concat(window.location.origin).concat(B2B_HOMEPAGE_PATH));
};
export var isSameAddress = function (first, second) {
    var _a, _b;
    // Address Line 2 can undefined from response or empty string from form -- strict equality is not sufficient
    var addrLine2Equal = (!first.postalDetails.addressLine2 && !second.postalDetails.addressLine2) ||
        ((_a = first.postalDetails.addressLine2) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
            ((_b = second.postalDetails.addressLine2) === null || _b === void 0 ? void 0 : _b.toLowerCase());
    return (first.postalDetails.addressLine1.toLowerCase() ===
        second.postalDetails.addressLine1.toLowerCase() &&
        addrLine2Equal &&
        first.postalDetails.city === second.postalDetails.city &&
        first.postalDetails.state === second.postalDetails.state &&
        first.postalDetails.country === second.postalDetails.country &&
        first.postalDetails.zipCode === second.postalDetails.zipCode);
};
export var buildAddressFromForm = function (values) {
    var firstName = values.firstName, lastName = values.lastName, phoneNumber = values.phoneNumber, cityState = values.cityState, companyAddress = values.companyAddress, companyAddressLine2 = values.companyAddressLine2, zipCode = values.zipCode;
    var _a = getCityStateObjectFromStr(cityState), city = _a.city, state = _a.state;
    return {
        name: { firstName: firstName, lastName: lastName },
        postalDetails: {
            city: city,
            addressLine1: companyAddress,
            addressLine2: companyAddressLine2 || undefined,
            state: state,
            country: 'US',
            zipCode: zipCode,
        },
        primaryPhone: { number: sanitizePhoneNumber(phoneNumber) },
    };
};
export var mapConvertToProValuesToRequestModel = function (customerData, values, isDefaultAddress) {
    var _a, _b, _c, _d, _e, _f;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var account = customerData.response.account;
    var companyName = values.companyName, tradeType = values.tradeType, token = values.token, firstName = values.firstName, lastName = values.lastName, phoneNumber = values.phoneNumber, otherBusiness = values.otherBusiness;
    var address = isDefaultAddress ? undefined : [buildAddressFromForm(values)];
    var newPrimaryPhone = {
        number: sanitizePhoneNumber(phoneNumber),
        primaryFlag: 'Y',
        type: 'UNKNOWN',
    };
    var currentMatchingPhone = ((_a = account === null || account === void 0 ? void 0 : account.profilePhones) === null || _a === void 0 ? void 0 : _a.phone) &&
        ((_c = (_b = account === null || account === void 0 ? void 0 : account.profilePhones) === null || _b === void 0 ? void 0 : _b.phone) === null || _c === void 0 ? void 0 : _c.find(function (phn) {
            return (phn.primaryFlag === newPrimaryPhone.primaryFlag &&
                phn.number === newPrimaryPhone.number);
        }));
    var phone = currentMatchingPhone && ((_d = account === null || account === void 0 ? void 0 : account.profilePhones) === null || _d === void 0 ? void 0 : _d.phone)
        ? __spreadArray([], account.profilePhones.phone, true) : __spreadArray([
        newPrimaryPhone
    ], (((_e = account === null || account === void 0 ? void 0 : account.profilePhones) === null || _e === void 0 ? void 0 : _e.phone) || [])
        .filter(function (phn) { return phn.number !== newPrimaryPhone.number; })
        .map(function (phn) { return (__assign(__assign({}, phn), { primaryFlag: 'N' })); }), true);
    var otherTradeDescription = tradeType === 'OTHR' ? otherBusiness : undefined;
    return {
        account: __assign(__assign({}, account), { token: token, profile: __assign(__assign({}, account === null || account === void 0 ? void 0 : account.profile), { name: {
                    firstName: firstName,
                    lastName: lastName,
                }, businessName: companyName, tradeType: tradeType, otherTradeDescription: otherTradeDescription, loyaltyEnrollmentIndicator: 'Y', emailId: undefined, zipCode: ((_f = account === null || account === void 0 ? void 0 : account.profile) === null || _f === void 0 ? void 0 : _f.zipCode) || values.zipCode }), profilePhones: __assign(__assign({}, account === null || account === void 0 ? void 0 : account.profilePhones), { phone: phone }), address: address }),
    };
};
